import API from "./api";

export interface EnregistrerVuePayload {
  chemin: string;
  langue?: string;
  sessionId?: string;
  articleId?: number;
}

const AnalyticsService = {
  enregistrerVue: async (payload: EnregistrerVuePayload) => {
    const response = await API.post("/analytics/vue", payload);
    return response.data.donnees;
  },

  enregistrerLecture: async (payload: EnregistrerVuePayload) => {
    const response = await API.post("/analytics/lecture", payload);
    return response.data.donnees;
  },

  resume: async () => {
    const response = await API.get("/analytics/resume");
    return response.data.donnees;
  },

  resumeMien: async () => {
    const response = await API.get("/analytics/resume/mien");
    return response.data.donnees;
  },

  statsArticle: async (articleId: number) => {
    const response = await API.get(`/analytics/articles/${articleId}`);
    return response.data.donnees;
  },
};

export default AnalyticsService;
